/**
 * @fileoverview gRPC-Web generated client stub for usrpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.usrpb = require('./administrator_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.AdministratorServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.AdministratorServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.Administrator,
 *   !proto.usrpb.CreateAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_CreateAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/CreateAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.Administrator,
  proto.usrpb.CreateAdministratorResponse,
  /**
   * @param {!proto.usrpb.Administrator} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CreateAdministratorResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.Administrator,
 *   !proto.usrpb.CreateAdministratorResponse>}
 */
const methodInfo_AdministratorService_CreateAdministrator = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.CreateAdministratorResponse,
  /**
   * @param {!proto.usrpb.Administrator} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CreateAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.CreateAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.CreateAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.createAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/CreateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CreateAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.CreateAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.createAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/CreateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CreateAdministrator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.Administrator,
 *   !proto.usrpb.UpdateAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_UpdateAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/UpdateAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.Administrator,
  proto.usrpb.UpdateAdministratorResponse,
  /**
   * @param {!proto.usrpb.Administrator} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.UpdateAdministratorResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.Administrator,
 *   !proto.usrpb.UpdateAdministratorResponse>}
 */
const methodInfo_AdministratorService_UpdateAdministrator = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.UpdateAdministratorResponse,
  /**
   * @param {!proto.usrpb.Administrator} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.UpdateAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.UpdateAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.UpdateAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.updateAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.UpdateAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.updateAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateAdministrator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.ChangePasswordRequest,
 *   !proto.usrpb.ChangePasswordResponse>}
 */
const methodDescriptor_AdministratorService_ChangePassword = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/ChangePassword',
  grpc.web.MethodType.UNARY,
  proto.usrpb.ChangePasswordRequest,
  proto.usrpb.ChangePasswordResponse,
  /**
   * @param {!proto.usrpb.ChangePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ChangePasswordResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.ChangePasswordRequest,
 *   !proto.usrpb.ChangePasswordResponse>}
 */
const methodInfo_AdministratorService_ChangePassword = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.ChangePasswordResponse,
  /**
   * @param {!proto.usrpb.ChangePasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ChangePasswordResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.ChangePasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.ChangePasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.changePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ChangePassword,
      callback);
};


/**
 * @param {!proto.usrpb.ChangePasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.ChangePasswordResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.changePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ChangePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AdministratorService_AcceptClientNotice = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/AcceptClientNotice',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_AdministratorService_AcceptClientNotice = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.acceptClientNotice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/AcceptClientNotice',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_AcceptClientNotice,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.acceptClientNotice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/AcceptClientNotice',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_AcceptClientNotice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.ListAdministratorRequest,
 *   !proto.usrpb.ListAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_ListAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/ListAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.ListAdministratorRequest,
  proto.usrpb.ListAdministratorResponse,
  /**
   * @param {!proto.usrpb.ListAdministratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListAdministratorResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.ListAdministratorRequest,
 *   !proto.usrpb.ListAdministratorResponse>}
 */
const methodInfo_AdministratorService_ListAdministrator = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.ListAdministratorResponse,
  /**
   * @param {!proto.usrpb.ListAdministratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.ListAdministratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.ListAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.ListAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.listAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/ListAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.ListAdministratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.ListAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.listAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/ListAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListAdministrator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.DeleteAdministratorRequest,
 *   !proto.usrpb.DeleteAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_DeleteAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/DeleteAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.DeleteAdministratorRequest,
  proto.usrpb.DeleteAdministratorResponse,
  /**
   * @param {!proto.usrpb.DeleteAdministratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.DeleteAdministratorResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.DeleteAdministratorRequest,
 *   !proto.usrpb.DeleteAdministratorResponse>}
 */
const methodInfo_AdministratorService_DeleteAdministrator = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.DeleteAdministratorResponse,
  /**
   * @param {!proto.usrpb.DeleteAdministratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.DeleteAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.DeleteAdministratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.DeleteAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.DeleteAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.deleteAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/DeleteAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_DeleteAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.DeleteAdministratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.DeleteAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.deleteAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/DeleteAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_DeleteAdministrator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.EmptyRequest,
 *   !proto.usrpb.ListDefaultAccessOptionResponse>}
 */
const methodDescriptor_AdministratorService_ListDefaultAccessOption = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/ListDefaultAccessOption',
  grpc.web.MethodType.UNARY,
  proto.usrpb.EmptyRequest,
  proto.usrpb.ListDefaultAccessOptionResponse,
  /**
   * @param {!proto.usrpb.EmptyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListDefaultAccessOptionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.EmptyRequest,
 *   !proto.usrpb.ListDefaultAccessOptionResponse>}
 */
const methodInfo_AdministratorService_ListDefaultAccessOption = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.ListDefaultAccessOptionResponse,
  /**
   * @param {!proto.usrpb.EmptyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListDefaultAccessOptionResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.EmptyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.ListDefaultAccessOptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.ListDefaultAccessOptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.listDefaultAccessOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/ListDefaultAccessOption',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListDefaultAccessOption,
      callback);
};


/**
 * @param {!proto.usrpb.EmptyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.ListDefaultAccessOptionResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.listDefaultAccessOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/ListDefaultAccessOption',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListDefaultAccessOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.Access,
 *   !proto.usrpb.CreateAccessResponse>}
 */
const methodDescriptor_AdministratorService_CreateAccess = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/CreateAccess',
  grpc.web.MethodType.UNARY,
  proto.usrpb.Access,
  proto.usrpb.CreateAccessResponse,
  /**
   * @param {!proto.usrpb.Access} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CreateAccessResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.Access,
 *   !proto.usrpb.CreateAccessResponse>}
 */
const methodInfo_AdministratorService_CreateAccess = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.CreateAccessResponse,
  /**
   * @param {!proto.usrpb.Access} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CreateAccessResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.Access} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.CreateAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.CreateAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.createAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/CreateAccess',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CreateAccess,
      callback);
};


/**
 * @param {!proto.usrpb.Access} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.CreateAccessResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.createAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/CreateAccess',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CreateAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.DeleteAccessRequest,
 *   !proto.usrpb.EmptyRequest>}
 */
const methodDescriptor_AdministratorService_DeleteAccess = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/DeleteAccess',
  grpc.web.MethodType.UNARY,
  proto.usrpb.DeleteAccessRequest,
  proto.usrpb.EmptyRequest,
  /**
   * @param {!proto.usrpb.DeleteAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.EmptyRequest.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.DeleteAccessRequest,
 *   !proto.usrpb.EmptyRequest>}
 */
const methodInfo_AdministratorService_DeleteAccess = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.EmptyRequest,
  /**
   * @param {!proto.usrpb.DeleteAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.EmptyRequest.deserializeBinary
);


/**
 * @param {!proto.usrpb.DeleteAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.EmptyRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.EmptyRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.deleteAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/DeleteAccess',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_DeleteAccess,
      callback);
};


/**
 * @param {!proto.usrpb.DeleteAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.EmptyRequest>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.deleteAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/DeleteAccess',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_DeleteAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.ListAccountAccessRequest,
 *   !proto.usrpb.ListAccountAccessResponse>}
 */
const methodDescriptor_AdministratorService_ListAccountAccess = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/ListAccountAccess',
  grpc.web.MethodType.UNARY,
  proto.usrpb.ListAccountAccessRequest,
  proto.usrpb.ListAccountAccessResponse,
  /**
   * @param {!proto.usrpb.ListAccountAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListAccountAccessResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.ListAccountAccessRequest,
 *   !proto.usrpb.ListAccountAccessResponse>}
 */
const methodInfo_AdministratorService_ListAccountAccess = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.ListAccountAccessResponse,
  /**
   * @param {!proto.usrpb.ListAccountAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListAccountAccessResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.ListAccountAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.ListAccountAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.ListAccountAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.listAccountAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/ListAccountAccess',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListAccountAccess,
      callback);
};


/**
 * @param {!proto.usrpb.ListAccountAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.ListAccountAccessResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.listAccountAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/ListAccountAccess',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListAccountAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.ForgotPasswordCheckEmailRequest,
 *   !proto.usrpb.ForgotPasswordCheckEmailResponse>}
 */
const methodDescriptor_AdministratorService_ForgotPasswordCheckEmail = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/ForgotPasswordCheckEmail',
  grpc.web.MethodType.UNARY,
  proto.usrpb.ForgotPasswordCheckEmailRequest,
  proto.usrpb.ForgotPasswordCheckEmailResponse,
  /**
   * @param {!proto.usrpb.ForgotPasswordCheckEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ForgotPasswordCheckEmailResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.ForgotPasswordCheckEmailRequest,
 *   !proto.usrpb.ForgotPasswordCheckEmailResponse>}
 */
const methodInfo_AdministratorService_ForgotPasswordCheckEmail = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.ForgotPasswordCheckEmailResponse,
  /**
   * @param {!proto.usrpb.ForgotPasswordCheckEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ForgotPasswordCheckEmailResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.ForgotPasswordCheckEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.ForgotPasswordCheckEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.ForgotPasswordCheckEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.forgotPasswordCheckEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/ForgotPasswordCheckEmail',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ForgotPasswordCheckEmail,
      callback);
};


/**
 * @param {!proto.usrpb.ForgotPasswordCheckEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.ForgotPasswordCheckEmailResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.forgotPasswordCheckEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/ForgotPasswordCheckEmail',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ForgotPasswordCheckEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.ForgotPasswordRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AdministratorService_ForgotPassword = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/ForgotPassword',
  grpc.web.MethodType.UNARY,
  proto.usrpb.ForgotPasswordRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.ForgotPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.ForgotPasswordRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_AdministratorService_ForgotPassword = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.ForgotPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.ForgotPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.forgotPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/ForgotPassword',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ForgotPassword,
      callback);
};


/**
 * @param {!proto.usrpb.ForgotPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.forgotPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/ForgotPassword',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ForgotPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.UpdateUserSettingsRequest,
 *   !proto.usrpb.UpdateUserSettingsResponse>}
 */
const methodDescriptor_AdministratorService_UpdateUserSettings = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/UpdateUserSettings',
  grpc.web.MethodType.UNARY,
  proto.usrpb.UpdateUserSettingsRequest,
  proto.usrpb.UpdateUserSettingsResponse,
  /**
   * @param {!proto.usrpb.UpdateUserSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.UpdateUserSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.UpdateUserSettingsRequest,
 *   !proto.usrpb.UpdateUserSettingsResponse>}
 */
const methodInfo_AdministratorService_UpdateUserSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.UpdateUserSettingsResponse,
  /**
   * @param {!proto.usrpb.UpdateUserSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.UpdateUserSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.UpdateUserSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.UpdateUserSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.UpdateUserSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.updateUserSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateUserSettings',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateUserSettings,
      callback);
};


/**
 * @param {!proto.usrpb.UpdateUserSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.UpdateUserSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.updateUserSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateUserSettings',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateUserSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.LazyUsersRequest,
 *   !proto.usrpb.LazyUsersResponse>}
 */
const methodDescriptor_AdministratorService_LazyUsers = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/LazyUsers',
  grpc.web.MethodType.UNARY,
  proto.usrpb.LazyUsersRequest,
  proto.usrpb.LazyUsersResponse,
  /**
   * @param {!proto.usrpb.LazyUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.LazyUsersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.LazyUsersRequest,
 *   !proto.usrpb.LazyUsersResponse>}
 */
const methodInfo_AdministratorService_LazyUsers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.LazyUsersResponse,
  /**
   * @param {!proto.usrpb.LazyUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.LazyUsersResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.LazyUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.LazyUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.LazyUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.lazyUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/LazyUsers',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_LazyUsers,
      callback);
};


/**
 * @param {!proto.usrpb.LazyUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.LazyUsersResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.lazyUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/LazyUsers',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_LazyUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.usrpb.CurrentUserDetailsResponse>}
 */
const methodDescriptor_AdministratorService_CurrentUserDetails = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/CurrentUserDetails',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.usrpb.CurrentUserDetailsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CurrentUserDetailsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.google.protobuf.Empty,
 *   !proto.usrpb.CurrentUserDetailsResponse>}
 */
const methodInfo_AdministratorService_CurrentUserDetails = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.CurrentUserDetailsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CurrentUserDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.CurrentUserDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.CurrentUserDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.currentUserDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/CurrentUserDetails',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CurrentUserDetails,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.CurrentUserDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.currentUserDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/CurrentUserDetails',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CurrentUserDetails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.usrpb.GetUserOtpAuthUrlResponse>}
 */
const methodDescriptor_AdministratorService_GetUserOtpAuthUrl = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/GetUserOtpAuthUrl',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.usrpb.GetUserOtpAuthUrlResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.GetUserOtpAuthUrlResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.google.protobuf.Empty,
 *   !proto.usrpb.GetUserOtpAuthUrlResponse>}
 */
const methodInfo_AdministratorService_GetUserOtpAuthUrl = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.GetUserOtpAuthUrlResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.GetUserOtpAuthUrlResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.GetUserOtpAuthUrlResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.GetUserOtpAuthUrlResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.getUserOtpAuthUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/GetUserOtpAuthUrl',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_GetUserOtpAuthUrl,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.GetUserOtpAuthUrlResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.getUserOtpAuthUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/GetUserOtpAuthUrl',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_GetUserOtpAuthUrl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.UpdateUserOtpAuthRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AdministratorService_UpdateUserOtpAuth = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/UpdateUserOtpAuth',
  grpc.web.MethodType.UNARY,
  proto.usrpb.UpdateUserOtpAuthRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.UpdateUserOtpAuthRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.UpdateUserOtpAuthRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_AdministratorService_UpdateUserOtpAuth = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.UpdateUserOtpAuthRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.UpdateUserOtpAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.updateUserOtpAuth =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateUserOtpAuth',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateUserOtpAuth,
      callback);
};


/**
 * @param {!proto.usrpb.UpdateUserOtpAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.updateUserOtpAuth =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateUserOtpAuth',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateUserOtpAuth);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.EmptyRequest,
 *   !proto.usrpb.EmptyRequest>}
 */
const methodDescriptor_AdministratorService_RemoveUserOtpAuth = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/RemoveUserOtpAuth',
  grpc.web.MethodType.UNARY,
  proto.usrpb.EmptyRequest,
  proto.usrpb.EmptyRequest,
  /**
   * @param {!proto.usrpb.EmptyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.EmptyRequest.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.EmptyRequest,
 *   !proto.usrpb.EmptyRequest>}
 */
const methodInfo_AdministratorService_RemoveUserOtpAuth = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.EmptyRequest,
  /**
   * @param {!proto.usrpb.EmptyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.EmptyRequest.deserializeBinary
);


/**
 * @param {!proto.usrpb.EmptyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.EmptyRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.EmptyRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.removeUserOtpAuth =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/RemoveUserOtpAuth',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_RemoveUserOtpAuth,
      callback);
};


/**
 * @param {!proto.usrpb.EmptyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.EmptyRequest>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.removeUserOtpAuth =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/RemoveUserOtpAuth',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_RemoveUserOtpAuth);
};


module.exports = proto.usrpb;

